import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerReview } from 'anchor-shared/lib/model/entity/customerReview';
import { PublicCustomerReview } from 'anchor-shared/lib/model/interface/public-customer-review';
import { AggregateReview } from 'anchor-shared/lib/model/interface/aggregate-review';
import { CustomerReviewStatus } from 'anchor-shared/lib/model/enum/customer-review-status';

@Injectable()
export class CustomerReviewDAO extends BaseDAO<CustomerReview> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.CUSTOMER_REVIEW);
  }

  createOrUpdateCharterReview(
    reviews: Partial<CustomerReview>,
  ): Observable<CustomerReview> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/create';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      reviews,
    };
    return this.apiHelper.apiCall<CustomerReview>(
      url,
      method,
      null,
      data,
      headers,
    );
  }

  getPublicVesselReviews(vesselId: number): Observable<{
    vesselReviews: PublicCustomerReview[];
    aggregateReviews: AggregateReview[];
  }> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/public-vessel-reviews/' +
      vesselId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<{
      vesselReviews: PublicCustomerReview[];
      aggregateReviews: AggregateReview[];
    }>(url, method, null, null, headers);
  }

  findByCharterIdForOwner(
    charterId: number,
    publicId: string,
  ): Observable<{ vesselReview; review }> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/get-review-for-owner/${charterId}/${publicId}`;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<{ vesselReview; review }>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  getReviewByCharterId(charterId: number): Observable<CustomerReview> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + `/${charterId}`;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<CustomerReview>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  getReviewCounts(vesselIds: number[]): Observable<{ [key: string]: number }> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/vessels-review-count`;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      vesselIds,
    };
    return this.apiHelper.apiCall<{ [key: string]: number }>(
      url,
      method,
      null,
      data,
      headers,
    );
  }

  getOwnerReviewCount(ownerId: number): Observable<{ count: number }> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/owner-review-count/' +
      ownerId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<{ count: number }>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  updateReviewStatus(
    charterId: number,
    status: CustomerReviewStatus,
  ): Observable<CustomerReview> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/update-review-status';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      charterId,
      status,
    };
    return this.apiHelper.apiCall<CustomerReview>(
      url,
      method,
      null,
      data,
      headers,
    );
  }
}
